export const config = {
  title: "Tres Potrillos Trucks Construction LLC | Cleveland, TX | Professional Construction Services",
  meta: {
    description:
      "Tres Potrillos Trucks Construction LLC delivers expert construction solutions in Cleveland, TX with 40+ years of experience. Specializing in roofing, construction services, and reliable equipment solutions. Building Futures, Exceeding Expectations!",
    keywords: [
      "Tres Potrillos Trucks Construction",
      "Cleveland TX Construction",
      "Construction Services Cleveland",
      "Roofing Cleveland TX",
      "Texas Construction Company",
      "Commercial Construction",
      "Residential Construction",
      "Construction Equipment Texas"
    ],
    author: "Tres Potrillos Trucks Construction LLC",
    canonicalUrl: "https://trespotrillosconstruction.com/",
  },
  sections: {
    header: {
      businessName: "Tres Potrillos Trucks Construction LLC",
    },
    sectionB: {
      heroTitle: "Building Futures, Exceeding Expectations!",
      heroSubtitle: "Expert Construction Solutions in Cleveland, TX - 40+ Years of Experience",
      learnAboutText: "Get In Touch",
      phoneNumber: "2818061455",
      phoneLabel: "(281) 806-1455",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1400405020/photo/modern-wooden-house-construction-site-at-daylight.jpg?s=612x612&w=0&k=20&c=GtIaRUcbyD_2watbZraYEtEsiDB1CCb3DZjq2G0Xz3E=",
      cardData: [
        {
          title: "40+ Years Experience",
          description:
            "Decades of proven expertise in construction, roofing, and professional solutions.",
        },
        {
          title: "Customer-Focused",
          description:
            "Tailored solutions designed to meet the unique demands of every project.",
        },
        {
          title: "Quality Craftsmanship",
          description:
            "Skilled professionals delivering precision, care, and excellence on every job.",
        },
      ],
      description:
        "Tres Potrillos Trucks Construction LLC delivers reliable, customer-focused solutions designed to meet the unique demands of every project. Our team combines professional expertise with a commitment to quality service, ensuring each job is handled with precision and care.",
    },
    sectionC: {
      servicesTitle: "Our Construction Services",
      servicesDescription:
        "Professional construction solutions tailored to your specific needs. With 40+ years of experience, we combine hands-on expertise with a commitment to quality service, ensuring every job is handled with precision and care. Our approach prioritizes efficiency, durability, and client satisfaction.",
      cards: [
        {
          title: "Roofing Services",
          description:
            "Transform your home or business with expert roofing solutions. Professional installation, repair, and maintenance with quality materials and skilled craftsmanship.",
          imageSrc: "https://images.unsplash.com/photo-1632778149955-e80f8ceca2e8?w=600&q=80",
          imageAlt: "Professional roofing service",
        },
        {
          title: "Construction Solutions",
          description:
            "Comprehensive construction services for residential and commercial projects. From planning to completion, we deliver reliable results that exceed expectations.",
          imageSrc: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600&q=80",
          imageAlt: "Construction project",
        },
        {
          title: "Equipment & Trucks",
          description:
            "Reliable construction equipment and truck services to support your project needs. Professional solutions that enhance efficiency and productivity.",
          imageSrc: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&q=80",
          imageAlt: "Construction equipment",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Residential Construction",
        "Commercial Construction",
        "Roof Repair & Maintenance",
        "New Construction",
        "Renovation & Remodeling",
        "Project Management",
      ],
    },
    sectionD: {
      aboutTitle: "About Tres Potrillos Trucks Construction LLC",
      aboutImage: {
        src: "https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/Clientes%2Fb3c63f65-6eb1-4fd3-aa9f-f5d132af2e46%2Fb3c63f65-6eb1-4fd3-aa9f-f5d132af2e46_whiteLogo.webp?alt=media&token=2e6bc44d-0b70-432e-a8c1-6ab3b58c841d",
        alt: "Tres Potrillos Construction team",
      },
      aboutText: [
        "Tres Potrillos Trucks Construction LLC is dedicated to delivering expert construction solutions through skilled craftsmanship, exceptional service, and a steadfast commitment to meeting our clients' unique needs with integrity and precision. With over 40 years of combined experience, we've built our reputation on quality work and customer satisfaction.",
        "At Tres Potrillos Trucks Construction LLC, we envision leading the industry through expert craftsmanship, innovative solutions, and unwavering dedication to customer success, consistently delivering exceptional service and lasting value. Our focus on quality craftsmanship, transparent communication, and reliable project management ensures excellence from start to finish.",
        "We combine deep industry expertise with a steadfast commitment to personalized service, delivering tailored solutions that meet each client's unique needs. By combining reliable equipment with a customer-focused approach, we ensure every job runs smoothly and exceeds expectations. Located in Cleveland, TX, we're proud to serve our community with professional construction solutions.",
      ],
    },
    sectionE: {
      profileImage: "https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/Clientes%2Fb3c63f65-6eb1-4fd3-aa9f-f5d132af2e46%2Fb3c63f65-6eb1-4fd3-aa9f-f5d132af2e46_whiteLogo.webp?alt=media&token=2e6bc44d-0b70-432e-a8c1-6ab3b58c841d",
      profileAlt: "Tres Potrillos Trucks Construction LLC Logo",
      businessName: "Tres Potrillos Trucks Construction LLC",
      contact: {
        phone: "2818061455",
        phoneLabel: "(281) 806-1455",
        email: "rh6319228@gmail.com",
        website: "https://trespotrillosconstruction.com/",
        address: "Cleveland, TX",
      },
      socialMedia: {
        tiktok: "https://www.tiktok.com/@tres.potrillos.tr"
      },
    },
    sectionF: {
      address: "Cleveland, TX",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27634.234!2d-95.0856!3d30.3416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x863876f4e4e4e4e4%3A0x1234567890abcdef!2sCleveland%2C%20TX!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;